import PropTypes from 'prop-types';
import { useState, useEffect } from "react";
import { MultiFilePreview } from "@heyjob-dash/shared/components/upload/index";

import {
  Stack,
  Dialog,
  AppBar,
  Button,
  Toolbar, Typography, DialogContent, DialogActions, CircularProgress
} from '@mui/material';

import FileService from "../services/FileService";
import { useAuthContext } from "../auth/hooks/index";
import CompanyService from "../services/CompanyService";


export default function DialogInvoices({ open, handleClose, invoices }) {

  const { user } = useAuthContext();

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const getFiles = async () => {
    setLoading(true);
    try {
      const filePromises = invoices.map(i => CompanyService.getSubscriptionInvoiceAttachment(
        user.data.current_company,
        i.id
      ));
      const fileResponses = await Promise.all(filePromises);
      const fileUrls = fileResponses.map(res => res.data);
      // merge all arrays
      setFiles([].concat(...fileUrls));
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    setFiles([]);
    if (open && invoices)
      getFiles().then();
  }, [invoices, open]);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
    >
      <AppBar sx={{ position: 'relative' }} elevation={0}>
        <Toolbar>
          <Typography
            sx={{ ml: 2, flex: 1 }}
            variant="h6"
            component="div"
            textAlign="center"
          >
            Dettaglio fatture
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Typography
          variant="body1"
          component="div"
          sx={{ mb: 2 }}
        >
          Le seguenti fatture sono state emesse e non risultano ancora saldate.
        </Typography>

        {loading && (<Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
          <CircularProgress variant="indeterminate" />
          <Typography
            variant="body1"
            component="div"
          >
            Caricamento file...
          </Typography>
        </Stack>)}

        <MultiFilePreview
          readOnly
          thumbnail
          files={files}
          onDownload={(inputFile) => FileService.downloadFile(inputFile.Key)} />
      </DialogContent>
      <DialogActions>
        <Button variant="soft" onClick={handleClose}>
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogInvoices.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  invoices: PropTypes.object,
};
